<template>
  <div>
    <vx-card>
      <div slot="no-body">
        <div class="vx-row flex items-center pt-5 px-5">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-left mb-4"
          >
            <div class="vx-card__title">
              <h4 class="">{{ $t("admin.tab.device") }}</h4>
            </div>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-2/3 lg:w-2/3 xl:w-2/3 text-right mb-4"
          >
            <vs-button color="warning" class="sx:w-full" @click="newRental">{{
              $t("admin.devices.CreateRentalBtn")
            }}</vs-button>
          </div>
        </div>
        <div style="border-top: 1px solid rgba(34, 41, 47, 0.125)"></div>
        <div class="vx-row flex items-center mx-5 mt-5 filter-vx-row">
          <div
            class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base"
          >
            <vs-input
              color="warning"
              name="search"
              icon-no-border
              icon="icon icon-search"
              icon-pack="feather"
              v-model="deviceTableSearch"
              class="w-full text-dark height-40"
              @input="deviceHandleSearch(deviceTableSearch)"
              :placeholder="$t('search.Text')"
              autocomplete="off"
            />
          </div>
          <div
            class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base"
          >
            <v-select
              :options="userAndCompanyOptions"
              @input="changeUserAndCompanyData"
              :clearable="true"
              :placeholder="$t('apiaries.filters.UserPlaceholder')"
              v-model="userAndCompanyValue"
              class="height-40"
              @search:blur="search = false"
              @search:focus="search = true"
            >
              <template #no-options>
                <div v-if="search == true && userAndCompanyOptions.length > 0">
                  {{ $t("apiaries.filters.NoResult") }}
                </div>
                <div v-else>
                  {{ $t("apiaries.filters.Empty") }}
                </div>
              </template>
            </v-select>
          </div>
          <div
            class="vx-col w-full sm:w-full md:w-1/2 lg:w-2/3 xl:w-1/3 mb-base"
          >
            <div class="w-full flex items-center custom-btn-group">
              <div>
                <vs-button
                  color="warning"
                  class="height-40 text-white border-left-radius"
                  @click="changeRentedOrNotRented(0)"
                  :class="rentedOrNotRented !== 0 ? 'btn-opacity75' : ''"
                  >{{ $t("admin.devices.filters.rented.all") }}</vs-button
                >
              </div>
              <div>
                <vs-button
                  color="warning"
                  class="height-40 text-white border-none-radius"
                  @click="changeRentedOrNotRented(1)"
                  :class="rentedOrNotRented !== 1 ? 'btn-opacity75' : ''"
                  >{{ $t("admin.devices.filters.rented.rented") }}</vs-button
                >
              </div>
              <div>
                <vs-button
                  color="warning"
                  class="height-40 text-white border-right-radius"
                  :class="rentedOrNotRented !== 2 ? 'btn-opacity75' : ''"
                  @click="changeRentedOrNotRented(2)"
                  >{{ $t("admin.devices.filters.rented.notRented") }}</vs-button
                >
              </div>
            </div>
          </div>
        </div>
        <div id="data-admin-device-view" class="data-list-container">
          <vs-table
            ref="table"
            :max-items="deviceItemsPerPage"
            :data="deviceList"
            :noDataText="deviceNoDataText"
            :sst="true"
            color="warning"
          >
            <template slot="thead">
              <vs-th>{{ $t("admin.devices.table.deviceSerial") }}</vs-th>
              <vs-th>{{ $t("admin.devices.table.simNumber") }}</vs-th>
              <vs-th>{{ $t("admin.devices.table.simProvider") }}</vs-th>
              <vs-th>{{ $t("admin.devices.table.rentalStatus") }}</vs-th>
              <vs-th>{{ $t("admin.devices.table.actions") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].device_serial">
                    <p class="font-medium truncate mr-0">
                      {{
                        data[indextr].device_serial
                          ? data[indextr].device_serial
                          : "-"
                      }}
                    </p>
                  </vs-td>
                  <vs-td :data="data[indextr].sim_number">
                    <p class="font-medium truncate mr-0">
                      {{
                        data[indextr].sim_number
                          ? data[indextr].sim_number
                          : "-"
                      }}
                    </p>
                  </vs-td>
                  <vs-td :data="data[indextr].sim_provider">
                    <p class="font-medium truncate mr-0">
                      {{
                        data[indextr].sim_provider == "TR"
                          ? "Turkcell"
                          : data[indextr].sim_provider == "VF"
                          ? "Vodafone"
                          : "-"
                      }}
                    </p>
                  </vs-td>
                  <vs-td :data="data[indextr].is_reserved">
                    <p class="font-medium truncate mr-0">
                      <vs-chip
                        transparent
                        :color="
                          data[indextr].is_reserved == true
                            ? 'success'
                            : 'danger'
                        "
                        class="font-bold px-4 text-center custom-chip"
                      >
                        {{
                          data[indextr].is_reserved == true
                            ? $t("admin.devices.chip.active")
                            : $t("admin.devices.chip.passive")
                        }}
                      </vs-chip>
                    </p>
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <p class="font-medium truncate mr-0">
                      <vs-button
                        type="border"
                        color="warning"
                        class="px-2 py-2"
                        @click="editDevice(data[indextr].id)"
                        >{{ $t("admin.devices.actionEditButton") }}</vs-button
                      >
                    </p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <div class="center con-pagination p-5">
            <div class="flex items-center justify-end">
              <div>
                <div class="con-vs-pagination vs-pagination-warning paginate">
                  <nav class="vs-pagination--nav">
                    <paginate
                      v-model="devicePage"
                      :page-count="deviceTotalPagination"
                      prev-text="<i class='vs-icon notranslate icon-scale material-icons null'>chevron_left</i>"
                      next-text="<i class='vs-icon notranslate icon-scale material-icons null'>chevron_right</i>"
                      container-class="vs-pagination--nav vs-pagination--ul"
                      page-class="item-pagination vs-pagination--li"
                      active-class="is-current"
                      disabled-class="disabled"
                      prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                      next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                    >
                    </paginate>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import i18n from '../../../i18n/i18n.js'
import vSelect from 'vue-select'
import Paginate from 'vuejs-paginate'
export default {
  data () {
    return {
      deviceItemsPerPage: 10,
      devicePage: 1,
      deviceTotalPagination: 1,
      deviceList: [],
      deviceNoDataText: i18n.t('admin.devices.NoDevice'),
      userAndCompanyOptions: [],
      userAndCompanyValue: null,
      search: false,
      rentedOrNotRented: 0,
      deviceTableSearch: '',
      isDeviceTableLoading: true,
      rootUrl: `${process.env.VUE_APP_ROOT_URL  }/api/device/management/`
    }
  },
  components: {
    vSelect,
    'paginate': Paginate
  },
  created () {
    this.getDeviceManagement(null)
    this.getUserSelectBoxData()
  },
  watch: {
    devicePage (val) {
      this.getDeviceManagement(
        this.rootUrl + this.deviceManagementFilters(val)
      )
    }
  },
  methods: {
    editDevice (id) {
      this.$router.push(`/admin/devices/edit/${  id}`).catch(() => {})
    },

    newRental () {
      this.$router.push('/admin/devices/rental/new').catch(() => {})
    },

    deviceManagementFilters (page) {
      let filter = `?page=${  page}`
      if (this.deviceTableSearch) {
        filter += `&search=${  this.deviceTableSearch}`
      }
      if (this.rentedOrNotRented !== 0) {
        filter += `&rented=${  this.rentedOrNotRented === 1}`
      }
      if (this.userAndCompanyValue && this.userAndCompanyValue.value !== null) {
        filter += `&user=${  this.userAndCompanyValue.value}`
      }

      if (this.deviceTableSearch.length > 3) {
        filter += `&search=${  this.deviceTableSearch}`
      }
      return filter
    },

    changeUserAndCompanyData () {
      this.devicePage = 1
      this.getDeviceManagement(this.rootUrl + this.deviceManagementFilters(1))
    },

    changeRentedOrNotRented (type) {
      this.rentedOrNotRented = type
      this.devicePage = 1
      this.getDeviceManagement(this.rootUrl + this.deviceManagementFilters(1))
    },

    deviceHandleSearch () {
      this.devicePage = 1
      this.getDeviceManagement(this.rootUrl + this.deviceManagementFilters(1))
    },

    getDeviceManagement (url) {
      this.isDeviceTableLoading = true
      this.usersNoDataText = i18n.t('admin.Loading')
      this.$store
        .dispatch('getDeviceManagement', url)
        .then((response) => {
          this.deviceList = []
          if (response.data.results.length === 0) {
            this.deviceNoDataText =
              url === null
                ? i18n.t('admin.devices.NoDevice')
                : i18n.t('admin.NoMatchingData')
            this.deviceTotalPagination = 1
          } else {
            this.deviceList.push(...response.data.results)
            this.deviceTotalPagination = Math.ceil(response.data.count / 10)
          }
          this.isDeviceTableLoading = false
        })
        .catch((error) => {
          this.deviceNoDataText = i18n.t('admin.NoDataError')
          this.isDeviceTableLoading = false
          this.errorMsg(error)
        })
    },

    getUserSelectBoxData () {
      this.$store
        .dispatch('getUserSelectBoxData')
        .then((response) => {
          this.userAndCompanyOptions = response
        })
        .catch((error) => {
          this.errorMsg(error)
        })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#data-admin-user-view,
#data-admin-device-view {
  .vs-con-table {
    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          width: 70px;
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        padding: 0 20px !important;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          justify-content: left !important;
          text-align: left;
        }
      }
      th.actions {
        .vs-table-text {
          justify-content: center !important;
        }
      }
      th.td-check {
        padding: 0 20px !important;
        width: 70px;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .vs-pagination--li.is-current {
    background: #ff9f43 !important;
  }
  .vs-pagination-primary .effect,
  .vs-pagination-primary .vs-pagination--buttons:hover {
    background: #ff9f43 !important;
  }

  .apiaries-list-part span {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }
  .not-data-table {
    background: #fff;
    padding: 20px;
    font-weight: 600;
    border-radius: 0.5rem;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  }
  .vs-table--tbody-table .tr-values.selected {
    cursor: default;
  }
}
.height-40 {
  min-height: 40px;
  .vs-input--input {
    height: 40px;
  }
}
.custom-btn-group button {
  padding: 0.75rem 0.75rem !important;
}

@media (min-width: 1200px) and (max-width: 1400px) {
  .filter-vx-row {
    .xl\:w-1\/3,
    .xl\:w-1\/4 {
      width: 50% !important;
    }
    .xl\:w-5\/12 {
      width: 60% !important;
    }
  }
}
@media (max-width: 575px) {
  .sx\:w-full {
    width: 100% !important;
  }
}

.border-left-radius {
  border-bottom-right-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
.border-right-radius {
  border-bottom-left-radius: 0px !important;
  border-top-left-radius: 0px !important;
}
.border-none-radius {
  border-radius: 0px !important;
}

.btn-opacity75 {
  opacity: 0.75;
}

.custom-chip {
  .vs-chip--text {
    margin: 0px;
  }
}

</style>
